var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "39px",
    viewBox: "0 0 31 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ManFoot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ManFoot",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.051144,6.21790555 L24.5290836,19.6376182 C29.1324503,28.4455738 32.4434553,32.5020259 30.3663203,36.6652734 L29.7763861,37.8396321 C27.9778365,39.7682997 23.8068166,39.300788 21.2580532,36.3766519 L2.13693946,14.835367 C-0.806319771,10.3320781 -0.99188462,4.55112953 3.37124484,2.92339481 C3.37124484,2.92339481 15.6082048,-1.51885528 16.9061007,0.548577259 C19.5150644,4.71093974 19.697726,2.61914807 22.051144,6.21790555",
    id: "Fill-120",
    fill: "#223A6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManFoot);
export default __webpack_public_path__ + "static/media/ManFoot.6130fdffb96858f839db876e50a383b6.svg";
export { ForwardRef as ReactComponent };